import { LazyImage, styled } from '@teko/ds-desktop';
import React from 'react';

const DetailGifts = ({
  gifts
}) => /* @__PURE__ */ React.createElement("div", null, gifts.map((gift, index) => /* @__PURE__ */ React.createElement(StyledGift, {
  key: index
}, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LazyImage, {
  height: 32,
  width: 32,
  border: true,
  borderRadius: 2,
  contain: true,
  src: (gift == null ? void 0 : gift.image.src) || ""
})), /* @__PURE__ */ React.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ React.createElement(GiftName, null, gift.name), gift.endAt && /* @__PURE__ */ React.createElement(EndAt, null, gift.endAt))));
const StyledGift = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = styled.span`
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = styled.span(({ theme }) => `
    color: ${theme == null ? void 0 : theme.colors.pending500};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity = styled.span`
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;

export { DetailGifts, Quantity };
